import React from 'react'
import classNames from 'classnames'
import { Button, Heading } from '@toasttab/shared/src/components'
import Eyebrow from '@toasttab/shared/src/components/molecules/Eyebrow/Eyebrow'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
import { PromoBlock } from './PromoBlock.d'

const PromoBlockModule = (promoBlock: PromoBlock) => {
  // dynamically create initialValues for Formik

  const eyebrowIcon = {
    src: 'https://d2w1ef2ao9g8r9.cloudfront.net/otl-images/icon/icon-resource.svg',
    width: '14',
    height: '14',
    position: 'left'
  }

  const eyebrowCss = classNames('text-default text-xs tracking-[0.1em] mb-4')

  const OrangeIllustrationImageWrapperCssClass = classNames(
    'h-auto bg-toast-orange-500 relative overflow-visible bg-img-benchmarking-lines',
    'rounded-t-lg md:rounded-tr-none  md:rounded-l-lg md:rounded-bl-lg md:bg-[left_calc(-151px)_top_calc(-16px)] min-w-[190px] bg-[left_calc(-95px)_top_calc(-100px)]',
    'md:min-w-[190px]'
  )

  return (
    <section className={`otl-gated-cta-long-form drop-shadow-lg md:mb-0 `}>
      <div
        className={
          'rounded-lg md:rounded-tl-none md:rounded-bl-none xl:rounded-lg flex flex-col md:flex-row bg-white overflow-hidden'
        }
      >
        <div className={OrangeIllustrationImageWrapperCssClass}>
          <div className='w-full h-[180px] md:h-full relative overflow-hidden'></div>
        </div>
        <div className={`p-6 md:p-10 w-full`}>
          <Eyebrow icon={eyebrowIcon} componentClass={eyebrowCss}>
            {promoBlock.blockLabel}
          </Eyebrow>
          {promoBlock.blockTitle && (
            <Heading
              id=''
              classes={'mb-1'}
              color={['text-black']}
              fontFamily='font-calibre'
              fontWeight='font-semibold'
              letterSpacing='tracking-normal'
              textAlign={['text-left']}
              width='w-full'
              fontSize={['text-otl-cta-heading']}
              leading={'leading-[110%]'}
              content={promoBlock.blockTitle}
              heading='h3'
            />
          )}
          <Typography
            as='p'
            variation='default'
            classes='font-sansPro text-lg text-default mb-4'
            allowHtml={false}
          >
            {promoBlock.blockDescription.blockDescription}
          </Typography>
          <div className='block mb-2'>
            {promoBlock.blockCtaText && promoBlock.blockLink && (
              <Button variation='primary' href={promoBlock.blockLink}>
                <span className='font-semibold leading-6 md:leading-4'>
                  {promoBlock.blockCtaText}
                </span>
              </Button>
            )}
          </div>
          <div className='mt-4'>
            <img
              src={resolvePrefix('/svg/img-toast-cta-branding.svg')}
              alt='Toast'
              className='mr-4'
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default PromoBlockModule
